(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('own-profile', {
            parent: 'entity',
            url: '/own-profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.ownProfile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/own-profile/own-profiles.html',
                    controller: 'OwnProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ownProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('own-profile-detail', {
            parent: 'entity',
            url: '/own-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.ownProfile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/own-profile/own-profile-detail.html',
                    controller: 'OwnProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ownProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OwnProfile', function($stateParams, OwnProfile) {
                    return OwnProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'own-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('own-profile-detail.edit', {
            parent: 'own-profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-dialog.html',
                    controller: 'OwnProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OwnProfile', function(OwnProfile) {
                            return OwnProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('own-profile.new', {
            parent: 'own-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-dialog.html',
                    controller: 'OwnProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                screenName: null,
                                age: null,
                                dob: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('own-profile', null, { reload: true });
                }, function() {
                    $state.go('own-profile');
                });
            }]
        })
        .state('own-profile.edit', {
            parent: 'own-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-dialog.html',
                    controller: 'OwnProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OwnProfile', function(OwnProfile) {
                            return OwnProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('own-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('own-profile.delete', {
            parent: 'own-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/own-profile/own-profile-delete-dialog.html',
                    controller: 'OwnProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OwnProfile', function(OwnProfile) {
                            return OwnProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('own-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
